module.exports = __webpack_public_path__ + "static/media/gif_operacionais.6b9960e4.gif";